export const styles = {
  cancelButton: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
    padding: '14px 12px',
    gap: '12px',
    width: '70px',
    height: '48px',
    background: '#FFFFFF',
    border: '1px solid #4D6EF5',
    borderRadius: '8px',
  },
  buttonContainer: { gap: '12px' },
  confirmAndDeleteButton: {
    color: '#D12D36',
    border: '1px solid #D12D36',
    '& svg': {
      width: '17px',
      height: '17px',
    },
    float: 'right',
  },
};
